"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringSubscriptionData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
exports.RecurringSubscriptionData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("recurringSubscription"),
    portal: UUID_1.UUID,
    site: UUID_1.UUID,
    subscription: UUID_1.UUID,
}));
//# sourceMappingURL=RecurringSubscriptionData.js.map